var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.funding.length)?_c('div',[(!_vm.sidebar)?_c('h2',[_vm._v("\n    Funding Breakdown\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('funding-split-allocation',{staticClass:"w-full",class:{
        'md:w-2/3 md:pr-24' : !_vm.sidebar,
        'pb-12' : _vm.sidebar
      },attrs:{"allocation":_vm.allocation}}),_vm._v(" "),_c('funding-split-breakdown',{staticClass:"w-full",class:{
        'md:w-1/3' : !_vm.sidebar
      },attrs:{"breakdown":_vm.breakdown}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }